import FlexRow from './FlexRow';

// A small-caps caption with a rule running off to the right.
//
// Settings cards tend to be a long run of inputs that all read alike; without
// visible seams they collapse into one undifferentiated stack and nothing tells
// the eye where one concern ends and the next begins. This is that seam.
export interface SectionRuleProps {
  caption:				string;
  className?:			string;
}

const SectionRule = (props: SectionRuleProps) => (
  <FlexRow align="center"
           className={['gap-[12px]', props.className || ''].join(' ')}>
    <span className="shrink-0 text-[--Dark-Grey] text-[11px] leading-[16px] tracking-[0.08em] uppercase">
      { props.caption }
    </span>
    <span className="grow h-[1px] bg-[--Lines]" />
  </FlexRow>
);

export default SectionRule;
